export default "/images/vendor/flag-icon-css/flags/1x1/jm.svg?74ccffca23e5a91356deb4060afdd5b9";